import React from "react"
const FormButton = ({changeState,state,onClick}) => {
    return (
        <div style={{width: '80%',margin: '20px', display:'flex',alignItems: 'center',justifyContent: 'center'}}>
            <button className="btn" onClick={(e)=>{if (onClick) onClick();changeState(state + 1);}} ><span className="Title" style={{fontSize: '30px'}}>Invia</span></button>
        </div>
    )
}
export default FormButton